const isDesktop = () =>
  typeof window !== "undefined" && Boolean(window.desktopPosMasterData);

const storageKey = (restaurantId, dataType) =>
  `billsarthi:pos-master:${String(restaurantId)}:${String(dataType)}`;

const readBrowserCache = (restaurantId, dataType) => {
  try {
    const raw = window.localStorage.getItem(storageKey(restaurantId, dataType));
    const value = raw ? JSON.parse(raw) : null;
    return Array.isArray(value?.records) ? value : null;
  } catch {
    return null;
  }
};

const writeBrowserCache = (restaurantId, dataType, records) => {
  try {
    window.localStorage.setItem(
      storageKey(restaurantId, dataType),
      JSON.stringify({ records, updatedAt: new Date().toISOString() })
    );
  } catch {
    // Storage can be unavailable/full; the Electron SQLite cache still works.
  }
};

export const getCachedPosMasterData = async (restaurantId, dataType) => {
  if (!restaurantId || !dataType) return null;
  if (isDesktop()) {
    try {
      const cached = await window.desktopPosMasterData.get({ restaurantId, dataType });
      if (cached?.records?.length) return cached;
    } catch {
      // Fall through to the browser cache.
    }
  }
  return readBrowserCache(restaurantId, dataType);
};

export const cachePosMasterData = async (restaurantId, dataType, records) => {
  if (!restaurantId || !dataType || !Array.isArray(records)) return null;
  writeBrowserCache(restaurantId, dataType, records);
  if (!isDesktop()) return { success: true, count: records.length };
  try {
    return await window.desktopPosMasterData.set({ restaurantId, dataType, records });
  } catch {
    return { success: false, count: records.length };
  }
};
